/* Stylesheet */

.sankey_diagram_options {
  display: flex;
  align-items: center;
  gap: 12px;
}
